/**
 * Function that returns array containing .env feature flags
 * @returns {Array}
 */
export const getFeatureFlags = () => {
  const featureFlagsSetting = `${
    (window.GPAC_ENV && window.GPAC_ENV.FEATURE_FLAGS) || process.env.REACT_APP_FEATURE_FLAGS
  }`;

  return featureFlagsSetting ? featureFlagsSetting.split('|') : [];
};

/**
 * Function that evaluates if the env contains the provided feature flags
 *
 * @param {string | Array<string> } featureFlags
 * @returns {boolean | Array<boolean>}
 */
export const hasFeatureFlag = featureFlags => {
  const appFeatureFlags = getFeatureFlags();
  if (Array.isArray(featureFlags)) {
    return featureFlags.map(flag => appFeatureFlags.includes(flag));
  }

  return appFeatureFlags.includes(featureFlags);
};
